import React, {Component} from 'react';
import './index.css';
import { connect } from '../../utils';

class DividerView extends Component{
  render(){
    const {id, layoutState} = this.props;
    const {containerPadding, width, alignValue, size, line, lineColor} = layoutState.getItemJS(id).props.values;
    let align = `divinder-${alignValue}`;
    let borderValue = `${size} ${line} ${lineColor}`;
    return(
      <div style={{
        boxSizing: 'border-box',
        position: 'relative',
        height: '100%',
        display: 'flex',
        padding:containerPadding,
        flex:1
      }}>
        <hr className={align} style={{border:borderValue, width:width}}/>
      </div>
    )
  }
}
export default connect('layoutState')(DividerView);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/DividerView.js